import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HeightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"height"}/>
}
